import { useEffect } from "react";

const CelebrationSound = ({ isVisible }) => {
  useEffect(() => {
    if (isVisible) {
      // Create a simple celebration sound using Web Audio API
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();

      // Create a sequence of beep sounds
      const playBeep = (frequency, time, duration) => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.frequency.setValueAtTime(frequency, time);
        oscillator.type = "sine";

        gainNode.gain.setValueAtTime(0.1, time);
        gainNode.gain.exponentialRampToValueAtTime(0.01, time + duration);

        oscillator.start(time);
        oscillator.stop(time + duration);
      };

      // Play a celebration melody
      const now = audioContext.currentTime;
      playBeep(523.25, now, 0.2); // C
      playBeep(659.25, now + 0.2, 0.2); // E
      playBeep(783.99, now + 0.4, 0.2); // G
      playBeep(1046.5, now + 0.6, 0.4); // High C
      playBeep(783.99, now + 1.0, 0.2); // G
      playBeep(1046.5, now + 1.2, 0.4); // High C
    }
  }, [isVisible]);

  return null; // This component doesn't render anything
};

export default CelebrationSound;
